import { render } from "./BusinessPermitsPerformanceDashboard.vue?vue&type=template&id=1c05a000&scoped=true"
import script from "./BusinessPermitsPerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessPermitsPerformanceDashboard.vue?vue&type=script&lang=js"

import "./BusinessPermitsPerformanceDashboard.vue?vue&type=style&index=0&id=1c05a000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c05a000"]])

export default __exports__